export const MessageType = {
  /**
   * Welcome message containing the list of categories the user can select from. The will contain sections that are
   * clickable by the user.
   */
  CATEGORIES_LIST: 'message.sys.list.category',
  /**
   * If the categories contain a list of sections, then this will be shown here.
   */
  SECTION_LIST: 'message.sys.list.section',
  /**
   * Show a list of articles that can be selected.
   */
  ARTICLE_LIST: 'message.sys.list.article',
  /**
   * Show a list of sections and articles that can be selected.
   */
  HYBRID_LIST: 'message.sys.list.hybrid',
  /**
   * A list of most important articles with options to directly connect to
   * the agent or browse other articles.
   */
  ARTICLE_LIST_WITH_OTHER_NAVIGATION: 'message.sys.list.article.other_navigation',
  /**
   * The preview of an article if necessary.
   */
  ARTICLE_PREVIEW: 'message.sys.article.preview',
  /**
   * If the article is short, then its shown as a complete message.
   */
  ARTICLE_FULL: 'message.sys.article.full',
  /**
   * A typing message from the system side. This message can only be shown when the user is browsing the
   * sections/articles or when someone is typing.
   */
  TYPING: 'message.sys.typing',
  /**
   * This message is from the user side. This happens when the user clicks any of the options from the list provided in any of the previous
   * message.
   */
  USER_SYSTEM_MESSAGE: 'message.sys.user.response',
  /**
   * A list of transactions from the user.
   */
  USER_TRANSACTIONS: 'message.sys.user.transaction',
  /**
   * User search for an article & asking for help.
   */
  USER_SEARCH_ARTICLE_MESSAGE: 'message.sys.user.search.article',
  /**
   * This type of message is shown when to ask if user query is resolved.
   */
  RESOLUTION: 'message.sys.resolution',

  PRE_SUPPORT_PROMPT: 'message.sys.pre_support_prompt',
  PRE_SUPPORT_PROMPT_RESOLVED: 'message.sys.pre_support_prompt.resolved',
  PRE_SUPPORT_PROMPT_BARE: 'message.sys.pre_support_prompt.bare',
  PRE_SUPPORT_PROMPT_SUPPORT_ONLY: 'message.sys.pre_support_prompt.confirmationSupport',
  PRE_SUPPORT_PROMPT_ACTION_ONLY: 'message.sys.pre_support_prompt.actionOnly',
  PRE_SUPPORT_PROMPT_ACTION_WITH_SUPPORT: 'message.sys.pre_support_prompt.actionWithSupport',
  PRE_SUPPORT_PROMPT_FAILED_RESOLUTION: 'message.sys.pre_support_prompt.failedResolution',
  PRE_SUPPORT_PROMPT_FAILED_RESOLUTION_WITH_SUPPORT: 'message.sys.pre_support_prompt.failedResolutionWithSupport',
  PRE_SUPPORT_PROMPT_METADATA_ONLY: 'message.sys.pre_support_prompt.metadataOnly',

  PRE_SUPPORT_ACKNOWLEDGEMENT: 'message.sys.pre_support_acknowledgement',
  PRE_SUPPORT_PREDICTION: 'message.sys.pre_support_prediction',

  ARTICLE_CHECK_FAILED_MESSAGE: 'message.sys.articleCheck.failed',

  /**
   * This is a chat message, either from the user or from the system.
   */
  CHAT_MESSAGE: 'message.chat',
  /**
   * A chat message, from the system, that is a result of a chat trigger.
   */
  CHAT_MESSAGE_FROM_TRIGGER: 'message.chat.trigger',
  /**
   * This is an error message shown to the user. Ideally, in the entire message stack, less than 1 error messages should be present.
   * All previous errors need to be cleared.
   * NOTE: Not currently used.
   */
  ERROR_MESSAGE: 'message.sys.error',
  /**
   * This is the generic basic version of the message.
   */
  DEFAULT: 'message.general',
  /**
   * A chat message that can be an image or any kind of media
   */
  MEDIA: 'message.sys.media',
  /**
   * An alternative action message that is used to navigate the user to a different page.
   */
  ALTERNATIVE_ACTIONS: 'message.sys.alternative_actions',
  /**
   * A message to show after metadata check rules.
   */
  METADATA_RESOLUTION: 'message.sys.resolution.metadata',
  /**
   * A message to show if metadata resolution helped.
   */
  ANY_OTHER_HELP_RESOLUTION: 'message.sys.resolution.any_other_help',
  /**
   * A message to show if metadata resolution was not helpful.
   */
  FAILED_RESOLUTION_MESSAGE: 'message.sys.resolution.failed',
  /**
   * Agent Request input.
   */
  AGENT_REQUEST_INPUT: 'message.chat.request.input.transactionList',
  /**
   * Agent Request input.
   */
  AI_AGENT_REQUEST_INPUT: 'message.chat.request.input.transactionList.ai',
  /**
   * User submits a list of transactions.
   */
  USER_SUBMIT_INPUT_TRANSACTION: 'message.chat.submit.input.transactionList',
  /**
   * Transaction selection message (deposits/withdrawals/bets).
   */
  TRANSACTION_SELECT: 'message.sys.chat.transaction.select',
  /**
   * User selected transactions message.
   */
  SELECTED_TRANSACTION: 'message.sys.user.transaction.selected',
  /**
   * Connect option selection message (live chat, voice call, open request, follow up).
   */
  CONNECT_OPTION_SELECT: 'message.sys.connect.option.select',
  /**
   * AI generated chat message.
   */
  AI_CHAT_MESSAGE: 'message.sys.chat.ai',
  /**
   * End User message for AI response.
   */
  USER_MESSAGE_FOR_AI: 'message.sys.user.ai',
  /**
   * A message to show when the user has reached the threshold of the AI conversation.
   */
  OVERLONG_AI_CONVERSATION_RESOLUTION: 'message.sys.resolution.overlong_ai_conversation',
  /**
   * A message to show when the user does not send any message for a configured time.
   */
  STALE_AI_CONVERSATION_RESOLUTION: 'message.sys.resolution.stale_ai_conversation',
  /**
   * A message to show when the user has been inactive for a while and the AI is asking if they want to continue.
   */
  USER_LOGIN_FROM_AI: 'message.sys.resolution.user_login_from_ai',
  /**
   * A message to show when the user selects voice call option, asking for confirmation.
   */
  VOICE_CONFIRMATION: 'message.sys.resolution.voice_confirmation',
  /**
   * Landing entry: confirm before starting AI voice call (separate from agent voice call).
   */
  LANDING_AI_VOICE_CONFIRMATION: 'message.sys.resolution.landing_ai_voice_confirmation',
  /**
   * After voice disclaimer, when the host app must confirm microphone access: ask the user to continue or cancel.
   */
  VOICE_NATIVE_MICRO_ACCESS_CONFIRMATION: 'message.sys.resolution.voice_native_micro_access',
  /**
   * A message to show when the user cancels a request, asking if they want to end chat or contact support.
   */
  CANCEL_REQUEST: 'message.sys.resolution.cancel_request',
  /**
   * A message to show when the user wants to end a live chat session, asking for confirmation.
   */
  END_LIVE_CHAT: 'message.sys.resolution.end_live_chat',
  /**
   * A message to show when the user wants to end a voice call session, asking for confirmation.
   */
  END_VOICE_CALL: 'message.sys.resolution.end_voice_call',
  /**
   * A message to show when the user requests restart chat, asking for confirmation.
   */
  RESTART_CHAT_RESOLUTION: 'message.sys.resolution.restart_chat',
} as const;
